<div *ngIf="!(isInitialized$ | async)" class="loader-container">
    <p>Loading...</p>
</div>

<div *ngIf="isInitialized$ | async">
<app-global-toast></app-global-toast>
<div class="main-body">
<app-header></app-header>
<div class="main-layout h-[92vh]">
    <app-sidebar (widthChange)="onSidebarWidthChange($event)"></app-sidebar>
    <div class="content" [style.marginLeft.px]="sidebarWidth">
        <router-outlet></router-outlet>
    </div>
</div>
</div>
</div>